

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'

import { Wallet3 } from '../../Components/Account/Wallet3.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import "./Account2.less"
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'

export class Account2 extends React.Component {


    constructor(props) {
        super(props);

        this.redirectDone = true;
        this.state = {
            redirectTo: '/', redirectToState: {}, promotions: null, activePokerReloadPromotion: null, activeTab: 'casino', fromSport: false, simple: false, isMobile: false
        }

        this.props.fetchUserFn();
        this.logout = this.logout.bind(this);
        this.showUser = this.showUser.bind(this);
        this.doRedirect = this.doRedirect.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.fetchData();
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Prijenos novca', 'casino', this.props.user);
    }

    componentDidMount() {
        const sportParam = new URLSearchParams(location.search).get("fromsport");
        if (sportParam && sportParam == "1") {
            this.setState({ activeTab: 'sport', fromSport: true });
        }
        const simpleParam = new URLSearchParams(location.search).get("simple");
        if (simpleParam && simpleParam == "1") {
            this.setState({ simple: true, activeTab: 'casino' });
        }

        this.setState({ isMobile: this.isMobileDevice() });

        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    isMobileDevice = () => {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    showUser(user, sesijaId) {
        this.props.updateUserFn(user, sesijaId);
    }

    fetchData() {
        var promises = Promise.all([casino.repos.promotionRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    doRedirect(path, state) {
        this.redirectDone = false;
        this.setState({
            redirectTo: path,
            redirectToState: state
        });
    }

    logout(redirectToHome) {
        var that = this;

        this.props.showLoadingFn(true);
        casino.repos.sessionRepo.remove().then(function () {
            that.showUser(null, null);
            that.props.showLoadingFn(false);
        });

        if (redirectToHome) {
            that.doRedirect(this.props.getHomePathFn(this.props.route.location));
        }
    }

    setData(data) {
        var [promotions] = data;

        let activePokerReloadPromotion = false;
        let runningPokerReloadPromotion = false;
        if (promotions && promotions.availableItems)
            promotions.availableItems.map(x => {
                if (x.poker)
                    activePokerReloadPromotion = true;
            })

        if (promotions && promotions.runningItems)
            promotions.runningItems.map(x => {
                if (x.poker)
                    runningPokerReloadPromotion = true;
            })

        this.setState({
            promotions: promotions,
            activePokerReloadPromotion: activePokerReloadPromotion,
            runningPokerReloadPromotion: runningPokerReloadPromotion
        });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
    }


    renderTotalAmount() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.ukupnoRaspolozivo, this.props.user.valuta);
    }

    renderAvaiableToWithdraw() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivoZaIsplatu + this.props.user.sportRaspolozivoZaIsplatu, this.props.user.valuta);
    }

    renderSportRasplozivo() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.sportRaspolozivo, this.props.user.valuta);
    }

    renderSportRasplozivoZaIsplatu() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.sportRaspolozivoZaIsplatu, this.props.user.valuta);
    }

    renderSportZakljucano() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.sportZakljucano, this.props.user.valuta);
    }

    renderCasinoRasplozivoZaIsplatu() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivoZaIsplatu, this.props.user.valuta);
    }

    renderCasinoRasplozivo() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivo, this.props.user.valuta);
    }

    renderCasinoBonusi() {
        return casino.utils.numberWithCurrencyFromated(this.props.user.casinoPrewagerBonusIznos, this.props.user.valuta);
    }



    ChevronRightIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
    );


    render() {
        var pathName = this.props.route.match.url;

        if (this.props.user) {
            return <div>
                <MetaTags title="Moj Račun | SuperSport Casino" description={" "} />
                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} {...this.props} ></Header>)} />

                <div className="flex margin-1p-on-tablet">

                    {!this.state.fromSport && <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>}

                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding">
                        {/* NEW PART START */}
                        <div className="wd-wallet-container-wrapper">
                            <div className="wd-wallet-container">
                                <header className="wd-header wd-anim wd-anim-slide-up">
                                    <span className="wd-username">{this.props.user.nadimak}</span>
                                    <button className="wd-deposit-btn">
                                        <span className="wd-deposit-icon"></span>
                                        <a href={casino.config.urls.uplata + (this.state.simple ? "&simple=1" : "")} target="_top">UPLATI</a>
                                    </button>
                                </header>

                                <div className="wd-balance-card wd-anim wd-anim-fade wd-anim-delay-1">
                                    <div className="wd-balance-main">
                                        <div className="wd-balance-info">
                                            <h3>Ukupno raspoloživo za igru</h3>
                                            <p className="wd-amount">{this.props.user && this.renderTotalAmount()}</p>
                                        </div>
                                    </div>
                                    <a href={"https://m.supersport.hr/racun#/isplata" + (this.state.simple ? "&simple=1" : "")} target="_top" className="wd-withdrawal-link">
                                        <span>Ukupno raspoloživo za isplatu</span>
                                        <span className="wd-amount">{this.props.user && this.renderAvaiableToWithdraw()}  {this.ChevronRightIcon()} </span>
                                    </a>
                                </div>

                                <Wallet3 {...this.state} key="wallet3" {...this.props} simple={this.state.simple} fetchDataFn={this.fetchData}></Wallet3>

                                <h2 className="wd-section-heading wd-anim wd-anim-slide-down wd-anim-delay-3">Moj novčanik</h2>

                                <div className="wd-tabs wd-anim wd-anim-slide-down wd-anim-delay-4">
                                    <button
                                        className={`wd-tab-button ${this.state.activeTab === 'sport' ? 'wd-active' : ''}`}
                                        onClick={() => this.setState({ activeTab: 'sport' })}
                                    >
                                        SPORT
                                    </button>
                                    <button
                                        className={`wd-tab-button ${this.state.activeTab === 'casino' ? 'wd-active' : ''}`}
                                        onClick={() => this.setState({ activeTab: 'casino' })}
                                    >
                                        CASINO I POKER
                                    </button>
                                </div>

                                {this.state.activeTab === 'sport' && (
                                    <div id="sport" className="wd-wallet-content wd-anim-tab-content">
                                        <ul className="wd-wallet-list">
                                            <li className="wd-list-item">
                                                <span className="wd-icon">
                                                    <span className="wd-icon-base wd-available-for-play" /></span>
                                                <span className="wd-label">Raspoloživo za igru</span>
                                                <span className="wd-value">{this.renderSportRasplozivo()}
                                                </span>
                                            </li>
                                            <li className="wd-list-item">
                                                <span className="wd-icon">
                                                    <span className="wd-icon-base wd-available-for-withdrawal" /></span>
                                                <span className="wd-label">Raspoloživo za isplatu</span>
                                                <span className="wd-value">{this.renderSportRasplozivoZaIsplatu()}
                                                </span>
                                            </li>
                                            {!this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/bonusi" target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-bonuses" />
                                                    </span>
                                                    <span className="wd-label">Sport bonusi</span>
                                                    <span className="wd-value">0,00 €</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/bonusi&simple=1" target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-bonuses" />
                                                    </span>
                                                    <span className="wd-label">Sport bonusi</span>
                                                    <span className="wd-value">0,00 €</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}

                                            {!this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/transakcije" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-transaction-history" /></span>
                                                    <span className="wd-label">Pregled transakcija</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/transakcije&simple=1" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-transaction-history" /></span>
                                                    <span className="wd-label">Pregled transakcija</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {!this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/isplata" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-withdraw-money" /></span>
                                                    <span className="wd-label">Isplata</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/isplata&simple=1" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-withdraw-money" /></span>
                                                    <span className="wd-label">Isplata</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                        </ul>

                                    </div>
                                )}

                                {this.state.activeTab === 'casino' && (
                                    <div id="casino" className="wd-wallet-content wd-anim-tab-content">
                                        <ul className="wd-wallet-list">
                                            <li className="wd-list-item">
                                                <span className="wd-icon">
                                                    <span className="wd-icon-base wd-available-for-play" />
                                                </span>
                                                <span className="wd-label">Raspoloživo za igru</span>
                                                <span className="wd-value">{this.renderCasinoRasplozivo()}</span>
                                            </li>
                                            <li className="wd-list-item">
                                                <span className="wd-icon">
                                                    <span className="wd-icon-base wd-available-for-withdrawal" />
                                                </span>
                                                <span className="wd-label">Raspoloživo za isplatu</span>
                                                <span className="wd-value">{this.renderCasinoRasplozivoZaIsplatu()}</span>
                                            </li>
                                            {!this.state.simple && <li className="wd-list-item">
                                                {!this.state.fromSport && <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')}>
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-bonuses" />
                                                    </span>
                                                    <span className="wd-label">Casino bonusi</span>
                                                    <span className="wd-value">{this.renderCasinoBonusi()}</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </NavLink>}
                                                {this.state.fromSport && <a href={this.state.isMobile ? "https://mcasino.supersport.hr/account/bonuses" : "https://casino.supersport.hr/racun/bonusi"} target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-bonuses" />
                                                    </span>
                                                    <span className="wd-label">Casino bonusi</span>
                                                    <span className="wd-value">{this.renderCasinoBonusi()}</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>}
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href={"https://mcasino.supersport.hr/casino-bonusi&simple=1"} className="wd-withdrawal-link">

                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-bonuses" />
                                                    </span>
                                                    <span className="wd-label">Casino bonusi</span>
                                                    <span className="wd-value">{this.renderCasinoBonusi()}</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {!this.state.simple && <li className="wd-list-item">
                                                {!this.state.fromSport && <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/transactions')}>
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-transaction-history" />
                                                    </span>
                                                    <span className="wd-label">Pregled transakcija</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </NavLink>}
                                                {this.state.fromSport && <a href={this.state.isMobile ? "https://mcasino.supersport.hr/account/transactions" : "https://casino.supersport.hr/racun/transakcije"} target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-transaction-history" />
                                                    </span>
                                                    <span className="wd-label">Pregled transakcija</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>}
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href={"https://mcasino.supersport.hr/pregled-transakcija&simple=1"} className="wd-withdrawal-link">

                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-transaction-history" />
                                                    </span>
                                                    <span className="wd-label">Pregled transakcija</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {!this.state.simple && <li className="wd-list-item">
                                                {!this.state.fromSport && <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/games')}>
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane igre</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </NavLink>}
                                                {this.state.fromSport && <a href={this.state.isMobile ? "https://mcasino.supersport.hr/account/games" : "https://casino.supersport.hr/racun/OdigraneIgre"} target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane igre</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>}
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href={"https://mcasino.supersport.hr/odigrane-igre&simple=1"} className="wd-withdrawal-link">

                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane igre</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {!this.state.simple && <li className="wd-list-item">
                                                {!this.state.fromSport && <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/free-games')}>
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane besplatne igre</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </NavLink>}
                                                {this.state.fromSport && <a href={this.state.isMobile ? "https://mcasino.supersport.hr/account/free-games" : "https://casino.supersport.hr/racun/OdigraneBesplatneIgre"} target="_top">
                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane besplatne igre</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>}
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href={"https://mcasino.supersport.hr/odigrane-besplatne-igre&simple=1"} className="wd-withdrawal-link">

                                                    <span className="wd-icon">
                                                        <span className="wd-icon-base wd-played-games" />
                                                    </span>
                                                    <span className="wd-label">Odigrane besplatne igre</span>
                                                    <span className="wd-arrow ml">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {!this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/isplata" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-withdraw-money" /></span>
                                                    <span className="wd-label">Isplata</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                            {this.state.simple && <li className="wd-list-item">
                                                <a href="https://m.supersport.hr/racun#/isplata?simple=1" target="_top"><span className="wd-icon">
                                                    <span className="wd-icon-base wd-withdraw-money" /></span>
                                                    <span className="wd-label">Isplata</span>
                                                    <span className="wd-arrow">{this.ChevronRightIcon()}</span>
                                                </a>
                                            </li>}
                                        </ul>

                                    </div>
                                )}

                                {!this.state.fromSport && <div className="wd-other-section wd-anim wd-anim-slide-down wd-anim-delay-6">
                                    <h2 className="wd-section-heading">Ostalo</h2>
                                    <Route exact path={pathName} render={(route) =>
                                        (<AccountLinkovi key="linkovi" {...this.props} path={pathName}></AccountLinkovi>)} />
                                    <hr />
                                    <button className="link link-20 red" onClick={() => this.logout(true)}>
                                        Odjavi me
                                    </button>
                                </div>}



                            </div>
                        </div>
                        {/* NOVI PART END */}
                    </div>


                </div>
            </div>

        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />

                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}
            </div>

        }
    }
};
